import { Bundle, CollectionProduct, WorkflowExperience } from '@spiffcommerce/core'
import { Dispatch } from 'react'
import { CustomScene } from '../../../types/types'
import { Button } from '../../Button/Button'
import { client } from '../../../../helpers/spiff'
import cn from 'classnames'
import {
  WORKFLOW_EXPERIENCE_OPTS,
  getPendantWorkflows,
  getTransformCollectionAndLength,
  updateWorkflowExperienceTransformsForPendants
} from '../../../helpers/spiffTransforms'

export const PendantOptions = ({
  currentScene,
  bundle,
  allWorkflows,
  pendantProducts,
  workflowPosition,
  sceneProductId,
  previewService,
  setIsLoading,
  bundleInit,
  isOnBodyPreview
}: {
  currentScene: CustomScene
  bundle: Bundle
  allWorkflows: WorkflowExperience[]
  pendantProducts: CollectionProduct[] | undefined
  workflowPosition: number
  sceneProductId: string
  previewService: any
  setIsLoading: Dispatch<React.SetStateAction<boolean>>
  bundleInit: () => void
  isOnBodyPreview: boolean
}) => {
  const changePendantWorkflow = async (product: CollectionProduct) => {
    if (!product) return

    setIsLoading(true)
    bundle.getWorkflowExperiences()[workflowPosition].getWorkflowManager().ejectFromPreviewService() // eject current pendant workflow from preview service
    const { transformCollection, currentLength } = getTransformCollectionAndLength({
      bundle,
      baseWorkflowExperience: allWorkflows[0]
    })

    if (!transformCollection || !currentLength) return

    const { transform, transformBody, workflowExperienceOpts } = getPendantWorkflows({
      product,
      position: currentScene.workflowPosition,
      quantity: allWorkflows.length - 1,
      transformCollection,
      currentLength
    })

    if (!transform || !transformBody) {
      console.error('pendant transform or transform body not found check config')
      return
    }
    const workflowExperiencesToAdd = await client.getWorkflowExperiences([workflowExperienceOpts], WORKFLOW_EXPERIENCE_OPTS)

    try {
      await bundle.replaceWorkflowExperience(workflowPosition, workflowExperiencesToAdd[0])
      const workflowExperienceAndTransforms = [
        {
          workflowExperience: workflowExperiencesToAdd[0],
          transform,
          transformBody
        }
      ]
      await updateWorkflowExperienceTransformsForPendants({
        workflowExperienceAndTransforms,
        isOnBodyPreview,
        bundle,
        previewService
      })

      bundleInit()
    } catch (error) {
      console.log('error', error)
    }

    setIsLoading(false)
  }

  return (
    <>
      <h3 className="flex min-h-0 px-5 py-0 mt-10 mb-5 Button">Step 1: Choose Type</h3>
      <div className="mx-5 px-0 flex flex-wrap gap-5 pb-[30px] mb-[30px] border-b border-solid border-ink/10">
        {pendantProducts?.map((product, i) => (
          <Button
            key={i}
            onClick={() => changePendantWorkflow(product)}
            selected={product.getResource().id === sceneProductId}
            className={cn('Button text-sm-b transition-none p-0 min-h-0 border-0 [&.Letter]:order-1 [&.Diamond]:order-2 [&.Charm]:order-3 [&.Birthstone]:order-4', product.getResource().id === sceneProductId ? 'underline underline-offset-4 bg-background-light p-0' : '', product.getResource().name.split('-')[0].trim())}
          >
            <span>{product.getResource().name.split('-')[0].trim()}</span>
          </Button>
        ))}
      </div>
    </>
  )
}
